import { render, staticRenderFns } from "./IconPending.vue?vue&type=template&id=a5213dfa&"
import script from "./IconPending.vue?vue&type=script&lang=js&"
export * from "./IconPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports